export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken'); 
  return {
    headers: {
      Authorization: token,
    },
  };
};